import { enableProdMode, ErrorHandler, importProvidersFrom, APP_INITIALIZER } from '@angular/core'
import { environment } from './environments/environment'
import { registerLicense } from '@syncfusion/ej2-base'
import { RoleGuard } from './app/guards/role-guard.service'
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store'
import { CustomSerializer } from './app/core/store/custom-serializer'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { RetryInterceptor } from '@shared/interceptors/retry.interceptor'
import { AuthInterceptor } from '@shared/interceptors/auth.interceptor'
import { ErrorLoggingService } from './app/error-logging.service'
import { NavService } from './app/nav.service'
import { BnNgIdleService } from 'bn-ng-idle'
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser'
import { provideAnimations } from '@angular/platform-browser/animations'
import { ContactSupportModule } from './app/contact-support/contact-support.module'
import { AppRoutingModule } from './app/app-routing.module'
import { StoreModule } from '@ngrx/store'
import { reducers } from './app/core/store'
import { EffectsModule } from '@ngrx/effects'
import { AppEffects } from './app/core/store/app.effects'
import { AuthEffects } from './app/core/store/auth/auth.effects'
import { ProgramEffects } from './app/core/store/program/program.effects'
import { ErrorModule } from './app/error/error.module'
import { MatSidenavModule } from '@angular/material/sidenav'
import { ReinsurerModule } from './app/reinsurers/reinsurer.module'
import { ProgramInitiationModule } from './app/program-initiation/program-initiation.module'
import { HotkeyModule } from 'angular2-hotkeys'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'
import { MatPseudoCheckboxModule, MatOptionModule } from '@angular/material/core'
import { MatSelectModule } from '@angular/material/select'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { TrackingModule } from './app/tracking/tracking.module'
import { MaintenanceModule } from './app/maintenance/maintenance.module'
import { AppComponent } from './app/app.component'
import { MessageDialogService } from '@shared/message-dialog.service'
import { provideStoreDevtools } from '@ngrx/store-devtools'
import { ConfirmationDialogService } from '@shared/services/confirmation-dialog.service'
import { AppInsightsService } from './app/core/telemetry/app-insights.service'

registerLicense(
  'ORg4AjUWIQA/Gnt3VVhhQlJDfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5adkZjUHpecXBcQGddWkd+',
)

if (environment.production) {
  enableProdMode()
}

const sharedChatThread = new URLSearchParams(window.location.search).get('chatThread')
if (sharedChatThread) {
  sessionStorage.setItem('sage.chatThread', sharedChatThread)
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      HttpClientModule,
      ContactSupportModule,
      AppRoutingModule,
      StoreModule.forRoot(reducers, {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
        },
      }),
      StoreRouterConnectingModule.forRoot({ serializer: CustomSerializer }),
      EffectsModule.forRoot([AppEffects, AuthEffects, ProgramEffects]),
      ErrorModule,
      MatSidenavModule,
      ReinsurerModule,
      ProgramInitiationModule,
      HotkeyModule.forRoot(),
      NgxMatSelectSearchModule,
      MatPseudoCheckboxModule,
      MatSelectModule,
      MatCheckboxModule,
      MatOptionModule,
      TrackingModule,
      MaintenanceModule,
    ),
    ...(!environment.production && !environment.uat
      ? [
          provideStoreDevtools({
            maxAge: 50,
            autoPause: true,
            connectInZone: true,
          }),
        ]
      : []),

    RoleGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: (appInsights: AppInsightsService) => () => appInsights.initialize(),
      deps: [AppInsightsService],
      multi: true,
    },
    { provide: RouterStateSerializer, useClass: CustomSerializer },
    { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: ErrorHandler, useClass: ErrorLoggingService },
    NavService,
    BnNgIdleService,
    provideAnimations(),
    MessageDialogService,
    ConfirmationDialogService,
  ],
}).catch((err) => console.error(err))
